import { useEffect, useState } from "react";
import LiveChatPanel from "./LiveChatPanel";
import { useLiveChat, AUTH_EVENT } from "../context/LiveChatContext";
import { useLanguage } from "../../../context/LanguageContext";
import { isLoggedIn } from "../../../utils/tokenUtils";
import { useActiveOrder } from "../../../utils/ActiveOrderContext";
import "../../../styles/style.css";

/**
 * Sağ altta duran destek düğmesi ve sohbet paneli.
 * Yalnızca giriş yapmış kullanıcılara görünür — /api/livechat tamamı [Authorize].
 */
function LiveChatWidget() {
  const { t } = useLanguage();
  const { isOpen, openChat, unreadCount } = useLiveChat();
  const { activeOrders } = useActiveOrder();
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());

  useEffect(() => {
    const sync = () => setLoggedIn(isLoggedIn());
    window.addEventListener(AUTH_EVENT, sync);
    window.addEventListener("session-expired", sync);
    return () => {
      window.removeEventListener(AUTH_EVENT, sync);
      window.removeEventListener("session-expired", sync);
    };
  }, []);

  if (!loggedIn) return null;

  return (
    <>
      {!isOpen && (
        <button
          className={`livechat-fab ${activeOrders.length > 0 ? "livechat-fab--raised" : ""}`}
          onClick={() => openChat()}
          aria-label={t("liveChat.title")}
          title={t("liveChat.title")}
        >
          <i className="bi bi-headset"></i>
          {unreadCount > 0 && <span className="livechat-fab__badge">{unreadCount}</span>}
        </button>
      )}

      <LiveChatPanel />
    </>
  );
}

export default LiveChatWidget;
